import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  InputAdornment,
  LinearProgress,
  Slide,
  TextareaAutosize,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Box } from "@mui/system";
import { IoCloseOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { setMentorVerificationStatusApi } from "../services/mentor_verfication.service";
import Toast from "./Toast";
import Constants from "../data/Constants";
import Utils from "../utils";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function MentorVerificationStatusDialog(props) {
  const {
    setMentorVerificationStatus,
    mentorVerificationStatus,
    onUpdate,
    setToast,
  } = props;

  const navigate = useNavigate();

  const [status, setStatus] = useState({
    loading: false,
    error: false,
    success: false,
  });

  useEffect(() => {
    setToast(status);
  }, [status]);

  const handleClose = () => {
    setMentorVerificationStatus(false);
  };

  const handleStatusChange = async (
    id,
    status,
    { reason = "", counsellingCostPrice, counsellingSalePrice }
  ) => {
    if (status == "SUCCESS") {
      if (!counsellingCostPrice || !counsellingSalePrice) {
        setStatus({
          loading: false,
          error: true,
          message: "Counselling Price is Required",
        });
        return;
      }
    }
    try {
      setStatus({
        loading: true,
        error: false,
      });

      await setMentorVerificationStatusApi(id, {
        status: status.toUpperCase(),
        message: reason,
        counsellingCostPrice,
        counsellingSalePrice,
      });

      setStatus({
        loading: false,
        error: false,
        success: true,
        message: "Updated Successfully",
      });

      handleClose();
      onUpdate(1); // notify parent to rerender changes
    } catch (error) {
      // error
      setStatus({
        loading: false,
        error: true,
        message: Utils.CustomErrorMessage(error),
      });
    }
  };
  return mentorVerificationStatus ? (
    <Dialog
      open={mentorVerificationStatus ? true : false}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>
        <Box display="flex" alignItems="center">
          <Box flexGrow={1}>
            <h2 className="font-extrabold text-lg">
              Mentor Verification Status
            </h2>
          </Box>
          <Box>
            <IconButton onClick={handleClose}>
              <IoCloseOutline />
            </IconButton>
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent>
        <div className="grid">
          {mentorVerificationStatus.status == "SUCCESS" ? (
            <div>
              Are you sure you want to approve the verification request?
              <div className="my-4">
                <TextField
                  label="Counselling Cost Price"
                  variant="filled"
                  size="small"
                  className="col-span-2"
                  fullWidth
                  required
                  name="amount"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">
                        {Constants.CURRENCY_SYMBOL}
                      </InputAdornment>
                    ),
                  }}
                  onChange={(e) => {
                    setMentorVerificationStatus({
                      ...mentorVerificationStatus,
                      counsellingCostPrice: e.target.value,
                    });
                  }}
                />
                <TextField
                  label="Counselling Sale Price"
                  variant="filled"
                  size="small"
                  className="col-span-2"
                  required
                  fullWidth
                  name="amount"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">
                        {Constants.CURRENCY_SYMBOL}
                      </InputAdornment>
                    ),
                  }}
                  onChange={(e) => {
                    setMentorVerificationStatus({
                      ...mentorVerificationStatus,
                      counsellingSalePrice: e.target.value,
                    });
                  }}
                />
              </div>
            </div>
          ) : (
            <div>
              Please provide a reason for declining the verification request
              <TextareaAutosize
                minRows={3}
                maxRows={5}
                aria-label="maximum height"
                placeholder="Rejection Reason"
                className="my-4 w-full border rounded-md p-2"
                onChange={(e) => {
                  setMentorVerificationStatus({
                    ...mentorVerificationStatus,
                    failedReason: e.target.value,
                  });
                }}
              />
            </div>
          )}
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Back</Button>

        {mentorVerificationStatus.status == "SUCCESS" ? (
          <Button
            color="success"
            onClick={() => {
              handleStatusChange(
                mentorVerificationStatus.id,
                mentorVerificationStatus.status,
                {
                  counsellingCostPrice:
                    mentorVerificationStatus.counsellingCostPrice,
                  counsellingSalePrice:
                    mentorVerificationStatus.counsellingSalePrice,
                }
              );
            }}
          >
            Approve
          </Button>
        ) : (
          <Button
            color="error"
            onClick={() => {
              handleStatusChange(
                mentorVerificationStatus.id,
                mentorVerificationStatus.status,
                { reason: mentorVerificationStatus.failedReason }
              );
            }}
          >
            Decline
          </Button>
        )}
      </DialogActions>
      {status.loading ? (
        <Box>
          <LinearProgress />
        </Box>
      ) : (
        ""
      )}
    </Dialog>
  ) : (
    ""
  );
}

export default MentorVerificationStatusDialog;
